export const callWhenIsNotDevelopment = fn => {
  if (process.env.NODE_ENV !== 'development') {
    fn();
  }
};
